module.exports = __webpack_public_path__ + "img/555.611271c7.png";